import { jsx as e, Fragment as d, jsxs as s } from "react/jsx-runtime";
import '../Divider.css';const a = "_dividerWrapper_451le_1", t = "_divider_451le_1", c = "_text_451le_11", r = {
  dividerWrapper: a,
  divider: t,
  text: c
}, v = ({ text: i }) => /* @__PURE__ */ e(d, { children: i ? /* @__PURE__ */ s("div", { className: r.dividerWrapper, children: [
  /* @__PURE__ */ e("hr", { className: r.divider }),
  /* @__PURE__ */ e("span", { className: r.text, children: i }),
  /* @__PURE__ */ e("hr", { className: r.divider })
] }) : /* @__PURE__ */ e("hr", { className: r.divider }) });
export {
  v as Divider
};
